function isNumber(evt) {
  evt = evt ? evt : window.event;
  const charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
  }
  return true;
}

const FormFieldUtils = {
  install: (Vue, options) => {
    Vue.prototype.$isNumber = isNumber;
  },
};

export default FormFieldUtils;
